import { Link } from "react-router-dom";

import { authLinkClass } from "@/pages/auth/AuthPageShell";

/**
 * Exit from logged-out auth pages to the app root of the current environment
 * (staging → staging `/`, production → production `/`) — not a hard-coded prod host.
 */
export function MarketingSiteLink({ className }: { className?: string }) {
  return (
    <Link
      to="/"
      className={className ?? `text-sm ${authLinkClass}`}
      data-testid="marketing-site-link"
    >
      Back to Zephix
    </Link>
  );
}
